import { observer } from 'mobx-react-lite'
import { Button, Form, Segment } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import Components from '../../app/common/components'
import { CRM_Metadata } from '../../app/stores/CRMStore/types';
import { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { columnType } from '../../app/common/components/DynamicRowsComponent';
import CutlistPreviewModal from '../MediaAssets/NFAI_Report/CutlistPreviewModal';
import ReallocationModal from './ReAllocation/ReallocationModal';
const SmarttrackerComponents = () => {
  const { commonStore,viewStore,reportStore,NFAI_Restoration_SmartflowsStore, userStore:{user}, activityStore } = useStore();
  const { HandleCutlistReelAnaylsis } = viewStore;
  const {titileInformation:{activeInformation},errorMessage,onSubmitChecker,subtaskCompoent, selectedItems} = NFAI_Restoration_SmartflowsStore;
  const mandatoryFieldsRef = useRef<any>({});
  const [,setRemovedRow] = useState<any>();
  const [,setAddedRow] = useState<any>();
  const [,setDataGridHeaders] = useState<any[]>([]);
  const [,setDataGridInitialValue] = useState<any[]>([]);
  const [viewShotsModel, setViewShotsModel] = useState<boolean>(false);
  const [viewShotLoader,setViewShotLoader] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(()=>{
  },[NFAI_Restoration_SmartflowsStore.subtaskCompoent.elements]);
const onChangeHandler = (
    e: any,
    { value }: { value: string },
    elements: CRM_Metadata,
  ) => {
    let result = '';
    let errorTemp = Object.assign({}, errorMessage);
    const localElement = [...subtaskCompoent.elements];
    const index = localElement.findIndex(
      (x) => x.elementName.toLowerCase() === elements.elementName.toLowerCase(),
    );
    const previousValue = subtaskCompoent.elements[index].elementValue || '';

    Array.isArray(value)
      ? (value = value.join(',').replace(/,/g, '|'))
      : (value = /datepicker/gi.test(elements?.elementType || '')
          ? e?.toLocaleDateString('en-GB')
          : elements?.elementType === 'DateTime'
            ? new Date(value).toDateString() +
              ' ' +
              new Date(value).toString().split(' ')[4]
            : value);
        if(index !== -1){
      localElement[index].elementValue = value;
        }else{
          toast.error(`${elements.elementName} is not updated.`)
    }

    // validation

    if (/textbox/gi.test(elements?.elementType || '')) {
      result = commonStore.genericValidation(
        value || '',
        elements?.validation || '',
      );
    }
    if (elements?.isMandatory && !value?.length) {
      result = 'This is mandatory field';
    }

    if (result) {
      errorTemp[`${elements?.elementId}`] = result;
      mandatoryFieldsRef.current[`${elements?.elementId}`] =
        elements?.elementId;
    } else {
      delete errorTemp[`${elements?.elementId}`];
      delete mandatoryFieldsRef.current[`${elements?.elementId}`];
    }

    if(/dropdown/gi.test(elements?.elementType || '')){
      let addLinkID = '';
      let removeLinkID = '';
      if (localElement?.[index]) localElement[index].elementValue = value;
      for (let j = 0; j < localElement[index].options?.length; j++) {
        if (previousValue === localElement[index]?.options?.[j]?.optionName) {
          removeLinkID = localElement[index]?.options?.[j]?.optionLinkId;
        }
        if (value === localElement[index]?.options?.[j]?.optionName) {
          addLinkID = localElement[index]?.options?.[j]?.optionLinkId;
        }
      }
      for (let i = 0; i < localElement?.length; i++) {
        if (localElement[i]?.templateElementId === removeLinkID) {
          if (localElement?.[i] !== undefined) {
            delete mandatoryFieldsRef.current[`${localElement?.[i]?.elementId}`];
            localElement[i].enableByDefault = false;
          }
        }
        if (localElement[i]?.templateElementId === addLinkID) {
          if (localElement?.[i] !== undefined) {
            mandatoryFieldsRef.current[`${localElement?.[i]?.elementId}`] =
              localElement?.[i].elementId;
            localElement[i].enableByDefault = true;
          }
        }
      }

    }
    NFAI_Restoration_SmartflowsStore.errorMessage = errorTemp;

    NFAI_Restoration_SmartflowsStore.subtaskCompoent.elements = localElement;
  };

  const saveDynamicTableData = async (
    data: any,
    validationData: any,
    removed: any,
    added: any,
    // alterHistory: string,
    initialElementValue: any,
    headers: columnType[],
  ) => {
    let copyElements = [...subtaskCompoent.elements];
    let indexOfData = copyElements?.findIndex(
      (localData: { templateElementId: string }) =>
        localData?.templateElementId === validationData?.templateElementId,
    );
    let payload = {
      ...validationData,
      elementValue: 'DynamicTable|' + JSON.stringify(data),
    };
    if (indexOfData < 0) {
      copyElements?.push(payload);
    } else {
      copyElements[indexOfData] = payload;
      if (validationData.elementName === 'QC Reject Reason') {
        const rejectIndex = copyElements.findIndex(
          (element) => element.elementName === 'Reject Reason',
        );
        if (rejectIndex !== -1) {
          let altpayload = {
            ...copyElements[rejectIndex],
            elementValue: 'DynamicTable|' + JSON.stringify(data),
          };
          copyElements[rejectIndex] = altpayload;
        }
      }
    }
    NFAI_Restoration_SmartflowsStore.subtaskCompoent.elements = copyElements;
    // setLocalDataElement(copyElements);
    if (removed.length > 0) {
      setRemovedRow((temp: any) => ({ ...temp, [validationData?.elementId]: removed }));
    }

    if (added.length > 0) {
      setAddedRow((temp: any) => ({ ...temp, [validationData?.elementId]: added }));
    }

    // Update headers
    if (headers) {
      setDataGridHeaders((tempValue) => ({
        ...tempValue,
        [validationData?.elementId]: [...headers],
      }));
    }

    // Update initialElementValue
    if (initialElementValue) {
      setDataGridInitialValue((tempValue) => ({
        ...tempValue,
        [validationData?.elementId]: [...initialElementValue],
      }));
    }
  };

  return (
    <>
    {commonStore.NFAIReportCustomer && viewShotsModel 
    && <CutlistPreviewModal 
          CutlistDetails={reportStore.NFAIReportCutlistPreviewList}
          viewShotsModel={viewShotsModel}
    setviewShotsModel={setViewShotsModel}/>}

        <Segment style={{width: '101%',overflow: 'auto'}}>
        <Form
          style={{
            position: 'relative',
            width: '100%',
            margin: '20px -10px',
          }}
        >
          <Form.Group widths="equal" className="workflowModalComponentsWrapper">
              
               <ReallocationModal isOpen={isOpen} setIsOpen={setIsOpen} />
        {NFAI_Restoration_SmartflowsStore.subtaskCompoent.elements.length > 0 && <>
               <Button size="large" onClick={() => setIsOpen(true)} style={{ width: '7vw' }}>
                Reallocation </Button>
                <Button
              loading={viewShotLoader}
              style={{ backgroundColor: 'lightgrey', color: 'black',float:'left',width:'150px',height:'40px' }}
              onClick={async () =>{
                setViewShotLoader(true);
                await HandleCutlistReelAnaylsis(activeInformation.parentId.split('/')[0] || '');
                    // if(viewStore.NFAIReportCutlistCheck){
                    //   toast.info('Reel Analysis file has to upload to start cutlist ');
                    //   return;
                    // }
                const reelNo = activeInformation?.title?.split('Reel')?.[1]?.split('-')?.[0]?.trim()
                const startFrame = activeInformation?.metadata.filter((m:any) => m.elementName === 'Start Frame')[0]?.elementValue
                const endFrame = activeInformation?.metadata.filter((m:any) => m.elementName === 'End Frame')[0]?.elementValue
                await reportStore.HandleCutlistPreivew(activeInformation?.id,reelNo,parseInt(startFrame),parseInt(endFrame));
                setViewShotsModel(true);
                setViewShotLoader(false);
              }}>
                  View Shots
                </Button>
        </>}
            {NFAI_Restoration_SmartflowsStore.subtaskCompoent?.elements
              ?.filter(() => true)
              ?.sort((a: any, b: any) => {
                if (a.elementIndex < b.elementIndex) return -1;
                if (a.elementIndex > b.elementIndex) return 1;
                return 0;
              })
              ?.map((item: any) => {
                // Check if elementName is "QC Reject Reason" and task is 'Cutlist Quality Check'
    if (item.elementName === "QC Reject Reason" && selectedItems.task === 'Cutlist Quality Check') {
      
                  // Ensure elementValue exists and has the expected format
                  if (item?.elementValue) {
                    const parts = item.elementValue.split('|');

                    if (parts.length > 1) {
                      let jsonString = parts[1]; // Extract JSON part

                      try {
                        // Parse the JSON string into an object
                        let data = JSON.parse(jsonString);

                        // Map through the data and update 'Reject By' and 'Reject Date'
                        data = data.map((e: any) => ({
                          ...e,
              'Reject By': e['Reject By'] === '' ? user?.displayName : e['Reject By'],
              'Reject Date': e['Reject Date'] === '' ? activityStore.updateDateTime()?.split(" ")[0]?.replace(/\//g, "-") : e['Reject Date'],
                        }));

                        // Convert back to string
                        item.elementValue = `DynamicTable|${JSON.stringify(data)}`;
  
                      } catch (error) {
                        console.error('Failed to parse JSON:', error);
                      }
                    }
                  }
                }

                return item;
              })
              ?.map((elem: any, index: number) => {
                return (
                  <Components
                    key={index} // Add a unique key for React components
                    elementDetails={elem}
        disabled={commonStore.filterModeZero?.includes(elem?.templateElementId || '')}
                    index={index}
                    saveDynamicTableData={saveDynamicTableData}
                    templateId={elem?.templateElementId || ''}
                    onChangeHandler={onChangeHandler}
                    errorMessage={onSubmitChecker ? errorMessage : ''}
                    RoleChecker={false}
                    onPhotoClick={() => {}}
                    getUploadedFiles={() => {}}
                    onConfirmUser={() => {}}
                    name={'NFAI Restoration SmartFlow'}
                  />
                );
              })}
          </Form.Group>
        </Form>
      </Segment>
    </>
  )
}

export default observer(SmarttrackerComponents);
